import React, { useState, Fragment, useEffect } from "react";
import { closeBtn, formBtn1, formBtn2, inputClass, labelClass} from "../Utils/CustomClasses";
import { Controller, useForm } from "react-hook-form";
import { Dialog, Transition } from "@headlessui/react";
import Error from "../Error/Error";
import { AddMispunchAPI, AssignUserAPI,UpdateMispunchAPI} from "../../API/Api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { customStyles } from "../Utils/CommonFuntion";
import Select from "react-select";
import moment from "moment";
import ButtonLoader from "../Loader/ButtonLoader";
import { IconEdit } from "@tabler/icons-react";

export default function Addmispunch({ edit, rowData, filterRecords, Company }) {
  
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const { register, handleSubmit, reset, control, setValue, formState: { errors },} = useForm();
  const [loader, setLoader] = useState(false);
  const [assignUsers, setAssignUsers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const assignToOptions =
    assignUsers != undefined
      ? assignUsers.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name}`,
        }))
      : [{ value: "", label: "No data found" }];

  const toggle = () => {
    setIsOpen(!isOpen);
    reset();
  };

  const handleCompanySelect = async (id) => {
    let companyId;
    companyId =
      userDetails?.role?.roleName == "Admin" ? userDetails?.company._id : id;
    setSelectedCompanyId(companyId);
    setValue("assign_to", null);
    setAssignUsers([]);
    try {
      let response2 = await AssignUserAPI({
        id: userDetails?._id,
        role: userDetails?.role?.roleName,
        company: companyId,
      });
      if (edit) {
        const filteredData = response2?.data?.filteredData?.filter(
          (user) => user?._id !== rowData?._id
        );
        setAssignUsers(filteredData);
      } else {
        setAssignUsers(response2?.data?.filteredData);
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  let timeoutId;
  const handleAssignChange = (selectedOption) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(async () => {
      try {
        let response = await AssignUserAPI({
          id: userDetails?._id,
          role: userDetails?.role?.roleName,
          search: selectedOption,
          company:
            userDetails?.role?.roleName === "Admin"
              ? userDetails?.company?._id
              : selectedCompanyId,
        });
        if (edit) {
          const filteredData = response?.data?.filteredData?.filter(
            (user) => user?._id !== rowData?._id
          );
          setAssignUsers(filteredData);
        } else {
          setAssignUsers(response?.data?.filteredData);
        }
      } catch (error) {
        console.error("Error assigning user:", error);
      }
    }, 1500);
  };

  useEffect(() => {
    if (isOpen && userDetails?.role?.roleName == "Admin") {
      handleCompanySelect(userDetails?.company?._id);
    }
    if (isOpen && edit) {
      reset({
        date: moment(rowData?.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
        inTime: moment(rowData?.inTime, ["hh:mm A", "HH:mm"]).format("HH:mm"),
        outTime: moment(rowData?.outTime, ["hh:mm A", "HH:mm"]).format("HH:mm"),
        comment: rowData?.comment,
        remark: rowData?.remark,
        userId: rowData?.userId?._id
          ? {
              value: rowData?.userId?._id,
              label: `${rowData?.userId?.first_name} ${rowData?.userId?.last_name}`,
            }
          : null,
        company: rowData?.company,
      });
    }
    if (
      isOpen &&
      edit === false &&
      userDetails?.role?.roleName !== "SuperAdmin"
    ) {
      setTimeout(() => {
        setValue("company", userDetails?.company?._id);
      }, 500);
    }
  }, [isOpen]);

  const onSubmit = async (data) => {
    setLoader(true);
    const payload = edit
      ? { remark: data?.remark }
      : {
          ...(userDetails?.role?.roleName === "SuperAdmin" ||
          userDetails?.role?.roleName === "Admin"
            ? {
                company: data?.company, // Use selected company ID
                userId: data?.userId?.value, // Use selected user ID
              }
            : {
                company: userDetails?.company?._id, // Use company ID from Redux
                userId: userDetails?._id, // Use user ID from Redux
              }),
          ...(data?.date && {
            date: moment(data?.date, "YYYY-MM-DD").format("DD-MM-YYYY"),
          }),
          ...(data?.inTime && {
            inTime: moment(data?.inTime, "HH:mm").format("hh:mm A"),
            comment: data?.comment,
          }),
          ...(data.outTime && {
            outTime: moment(data.outTime, "HH:mm").format("hh:mm A"),
          }),
        };

    try {
      let response;
      if (edit) {
        response = await UpdateMispunchAPI(rowData?._id, payload);
      } else {
        response = await AddMispunchAPI(payload);
      }
      if (response?.status == 201) {
        setLoader(false);
        toast.success(response?.data?.message);
        filterRecords();
        toggle();
      } else {
        setLoader(false);
        toast.error(response?.response?.data?.error);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error:", error);
    }
  };

  return (
    <>
      {edit ? (
        <button
          onClick={toggle}
          className="py-1 rounded-lg flex justify-center w-[24%]"
        >
          <IconEdit stroke={1.5} size={24} color="#000"/>
        </button>
      ) : (
        <>
          <div className="flex gap-4 ">
            <button onClick={toggle} className={formBtn1}>
              Apply Mispunch
            </button>
          </div>
        </>
      )}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={toggle}>
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-scroll ">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-2xl text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                  <Dialog.Title as="h2" className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb">
                    {edit ? "Edit Mispunch" : "Add Mispunch"}
                  </Dialog.Title>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                      {userDetails?.role?.roleName !== "SuperAdmin" &&
                      userDetails?.role?.roleName !== "Admin" ? (

                        <>
                          {/* Date Field */}
                          <div className="">
                            <label className={labelClass}>
                              Date<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className={inputClass}
                              max={moment().format("YYYY-MM-DD")}
                              {...register("date", { required: true })}
                            />
                            {errors.date && <Error title="Date is Required*" />}
                          </div>

                          {/* In Time Field */}
                          <div className="">
                            <label className={labelClass}>
                              In Time<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="time"
                              className={inputClass}
                              {...register("inTime", { required: true })}
                            />
                            {errors.inTime && (
                              <Error title="In Time is Required*" />
                            )}
                          </div>

                          {/* Out Time Field */}
                          <div className="">
                            <label className={labelClass}>
                              Out Time<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="time"
                              className={inputClass}
                              {...register("outTime", { required: true })}
                            />
                            {errors.outTime && (
                              <Error title="Out Time is Required*" />
                            )}
                          </div>

                          {/* Comment Field */}
                          <div className="">
                            <label className={labelClass}>
                              Comment<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("comment", { required: true })}
                            />
                            {errors.comment && (
                              <Error title="Comment is Required*" />
                            )}
                          </div>
                        </>
                      ) : (  
                        <>
                          <div className="">
                            <label className={labelClass}>
                              Company Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className={inputClass}
                              {...register("company", { required: true })}
                              onChange={(e) =>
                                handleCompanySelect(e.target.value)
                              }
                              disabled={
                                edit || userDetails?.role?.roleName !== "SuperAdmin"
                              }
                            >
                              <option value="">Select Company Name</option>
                              {Company?.map((company) => (
                                <option value={company?._id} key={company?._id}>
                                  {company?.companyName}
                                </option>
                              ))}
                            </select>
                            {errors.company && (
                              <Error title="Company Name is Required*" />
                            )}
                          </div>

                          {/* Select user Field */}
                          <div className="">
                            <label className={labelClass}>
                              Select User<span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="form-group">
                              <Controller name="userId" control={control} rules={{ required: "User is Required*" }}
                                render={({ field }) => (
                                  <Select
                                    value={field.value || null}
                                    options={assignToOptions}
                                    placeholder="Select User"
                                    styles={customStyles}
                                    maxMenuHeight={150}
                                    menuPlacement="auto"
                                    isDisabled={edit}
                                    onChange={(selectedOption) => {
                                      field.onChange(selectedOption); // Update form state
                                      handleAssignChange(selectedOption); // Call custom function
                                    }}
                                    onInputChange={(inputValue, { action }) => {
                                      if (action === "input-change") {
                                        handleAssignChange(inputValue); // Call function on typing
                                      }
                                    }}
                                    {...field}
                                  />
                                )}
                              />
                              {errors.userId && (
                              <Error title={errors.userId.message} />
                            )}
                            </div>
                          </div>

                          {/* Date Field */}
                          <div className="">
                            <label className={labelClass}>
                              Date<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className={inputClass}
                              max={moment().format("YYYY-MM-DD")}
                              disabled={edit}
                              {...register("date", { required: true })}
                            />
                            {errors.date && <Error title="Date is Required*" />}
                          </div>

                          {/* In Time Field */}
                          <div className="">
                            <label className={labelClass}>
                              In Time<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="time"
                              className={inputClass}
                              disabled={edit}
                              {...register("inTime", { required: true })}
                            />
                            {errors.inTime && (
                              <Error title="In Time is Required*" />
                            )}
                          </div>

                          {/* Out Time Field */}
                          <div className="">
                            <label className={labelClass}>
                              Out Time<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="time"
                              className={inputClass}
                              disabled={edit}
                              {...register("outTime", { required: true })}
                            />
                            {errors.outTime && (
                              <Error title="Out Time is Required*" />
                            )}
                          </div>

                          {/* Comment Field */}
                          <div className="">
                            <label className={labelClass}>
                              Comment<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              disabled={edit}
                              {...register("comment", { required: true })}
                            />
                            {errors.comment && (
                              <Error title="Comment is Required*" />
                            )}
                          </div>
                          
                          {/* Remark Field */}
                          {edit && (
                            <div className="">
                              <label className={labelClass}>
                                Remark<span style={{ color: "red" }}>*</span>
                              </label>
                              <select
                                className={inputClass}
                                {...register("remark", { required: true })}
                              >
                                <option value="">Select Remark</option>
                                <option value="Approved">Approved</option>
                                <option value="Rejected">Rejected</option>
                                <option value="Pending">Pending</option>
                              </select>
                              {errors.remark && <Error title="Remark is Required*" />}
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                      {loader ? (
                        <ButtonLoader />
                      ) : (
                        <button
                          type="submit"
                          className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                        >
                          <span className="opacity-100">
                            {edit ? "Update" : "Submit"}
                          </span>
                        </button>
                      )}
                      <button type="button" className={`${closeBtn}`} onClick={toggle}>Close</button>
                    </footer>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}